import * as actionType from "./actionTypes";
import { getAsofDate } from "../../utils/date";

/** Authentication check */
const getIsAuthenticated = () => {
	return localStorage.getItem("adal.idtoken") == "" ||
		localStorage.getItem("adal.idtoken") == null ||
		localStorage.getItem("adal.idtoken") == undefined
		? false
		: true;
};

/** Tenant Login check */
const getIsTenantLogin = () => {
	return localStorage.getItem("DCLT") == "" ||
		localStorage.getItem("DCLT") == null ||
		localStorage.getItem("DCLT") == undefined
		? false
		: true;
};
const initialState = {
	isInErrorState: false,
	commonLabel: null,
	asOfDate: getAsofDate(),
	isAuthenticated: getIsAuthenticated(),
	IsTenantLayoutType: getIsTenantLogin(),
	notificationData: [],
	fetchDate: new Date(),
	reload: !false
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionType.SET_ERROR_PAGE:
			return {
				...state,
				isInErrorState: true,
				isAuthenticated: getIsAuthenticated(),
				commonLabel: action.payload
			};
		case actionType.CLEAR_ERROR_PAGE:
			return {
				...state,
				isInErrorState: false,
				isAuthenticated: getIsAuthenticated(),
				commonLabel: action.payload
			};
		case actionType.SET_AS_OF_DATE:
			localStorage.setItem("ASOFDATE", JSON.stringify(action.payload));
			return {
				...state,
				isInErrorState: false,
				asOfDate: action.payload
			};
		case actionType.GET_NOTIFICATION_DATA:
			return {
				...state,
				isInErrorState: false,
				notificationData: action.payload,
				fetchDate: new Date(),
				reload: !state.reload
			};
		default:
			return state;
	}
};

export default reducer;
